import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { GenericObject } from '../interfaces/generic-object';

@Injectable({
  providedIn: 'root'
})
export class GoogleService {
  constructor(private http: HttpClient) {}

  addressAutoComplete(request: { input: string }, query = {}) {
    return this.http.post<GenericObject>(
      `/api/v2/google/addressAutoComplete`,
      request,
      { params: query }
    );
  }

  addressDetails(request: { PlaceId: string }, query = {}) {
    return this.http.post<GenericObject>(
      `/api/v2/google/addressDetails`,
      request,
      { params: query }
    );
  }
}
